module.exports = __webpack_public_path__ + "static/media/afternoon-tea.d7065e6c.jpg";